let i
const agesInEnglish = []
const agesInFrench = []
const minAge = 55
const maxAge = 85
const agesSelect = []
for (i = minAge; i < maxAge + 1; i++) {
  agesInEnglish.push(`${i} years old`)
  agesInFrench.push(`${i} ans`)
  agesSelect.push(i)
}

export default {
  en: agesInEnglish,
  fr: agesInFrench
}

export { agesSelect }



// WEBPACK FOOTER //
// ./src/utils/ages.data.js